import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { CreateCustomTalkingPointInput } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const CreateCustomTalkingPointMutation = graphql(`
  mutation CreateCustomTalkingPoint($input: CreateCustomTalkingPointInput!) {
    createCustomTalkingPoint(input: $input) {
      id
      __typename
      client {
        id
        __typename
        name
        externalReference
      }
      title
      userDetailsId
      createdAt
      completedAt
    }
  }
`);

export function useCreateCustomTalkingPoint() {
  const [result, createCustomTalkingPointMutation] = useMutation(CreateCustomTalkingPointMutation);
  const [error, setError] = useState<Error | null>(null);

  const createCustomTalkingPoint = useCallback(
    async (input: CreateCustomTalkingPointInput) => {
      try {
        const response = await createCustomTalkingPointMutation({ input });
        if (response.error) {
          throw response.error;
        }
        return response.data?.createCustomTalkingPoint;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [createCustomTalkingPointMutation],
  );

  return { createCustomTalkingPoint, result, error };
}
